export default __webpack_public_path__ + "static/media/nusa_video.cb1c43c0.mp4";